import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import Rowbox from '../Common/Rowbox'
import { CountDown } from 'hlj-components'
import style from './index.module.less'
import {
  DECORATION_MERCHANT_ACTIVITY,
  ACTIVITY_STATUS_PADDING,
  ACTIVITY_STATUS_FAIL
} from '@constant'
import { dGet } from '@core/utils'

const getActivityArea = props => {
  const { cover_path, title, start_date, end_date } = props
  const hasDateInfo = start_date && end_date
  return (
    <div className={style.content}>
      {cover_path ? (
        <img className={style.cover} src={cover_path} />
      ) : (
        <div className={style.coverEmpty} />
      )}

      <div className={cover_path ? style.bar : style.barEmpty}>
        {!hasDateInfo ? (
          <span className={style.timeContent}>活动报名中</span>
        ) : (
          <CountDown end={end_date}>
            {({ completed, days, hours, minutes, seconds }) => {
              return completed ? (
                <span className={style.timeContent}>
                  距离活动仅剩
                  <span className={style.timeBlock}>00</span>天<span
                    className={style.timeBlock}
                  >
                    00
                  </span>:<span className={style.timeBlock}>00</span>:<span
                    className={style.timeBlock}
                  >
                    00
                  </span>
                </span>
              ) : (
                <Fragment>
                  <span className={style.timeContent}>
                    距离活动仅剩
                    <span className={style.timeBlock}>{days}</span>天<span
                      className={style.timeBlock}
                    >
                      {hours}
                    </span>:<span className={style.timeBlock}>{minutes}</span>:<span
                      className={style.timeBlock}
                    >
                      {seconds}
                    </span>
                  </span>
                </Fragment>
              )
            }}
          </CountDown>
        )}

        {/* <span>{concerns_count || 10000}关注</span> */}
      </div>

      <div className={style.textArea}>
        {cover_path ? (
          <p className={style.activityName}>{title}</p>
        ) : (
          <p className={style.activityNameEmpty} />
        )}
        {cover_path ? (
          hasDateInfo && (
            <p className={style.time}>{`活动时间 ${
              (start_date || '').split(' ')[0]
            }~${(end_date || '').split(' ')[0]}`}</p>
          )
        ) : (
          <p className={style.timeEmpty} />
        )}
      </div>
    </div>
  )
}
@observer
export default class extends Component {
  getStatus = () => {
    const { allStatus } = this.props.store

    let status = ''

    const activity = dGet(allStatus, 'merchant_activity', {})
    if (activity) {
      if (activity.status == ACTIVITY_STATUS_FAIL) {
        status = 'rejected'
      } else if (activity.status == ACTIVITY_STATUS_PADDING) {
        status = 'verifying'
      }
    }

    return status
  }

  render() {
    const { activityData, mode } = this.props.store
    const status = this.getStatus()
    return mode === 'editable' ||
      (mode === 'preview' && activityData && activityData.cover_path) ? (
      <Rowbox
        type={DECORATION_MERCHANT_ACTIVITY}
        store={this.props.store}
        style={{
          flexDirection: 'column',
          padding: '20px 16px',
          height: 'auto',
          marginTop: 10
        }}
        vCenter={false}
        status={status}
      >
        {getActivityArea(activityData)}
      </Rowbox>
    ) : null
  }
}
